import { ExportIcon } from "@xola/icons";
import { FadeIn, Switch } from "@xola/ui-kit";
import React, { useState } from "react";
import { useModal } from "../../../hooks/useVisibility";
import { getEarningReportTransactionsParams } from "../../../models/Reports";
import { useEarningsReportFilterStore } from "../../../stores/reports/earningsReportFilterStore";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ExportTransactionsModal } from "../ExportTransactionsModal";
import { EarningsReportTransactionsList } from "./EarningsReportTransactionsList";
import { GroupByReservationist } from "./GroupedByReservationist";

export const EarningsReportTransactions = () => {
    const exportModal = useModal(false);
    const [isGroupByReservationist, setIsGroupByReservationist] = useState(false);

    const dateParams = useEarningsReportFilterStore((state) => state.getDateParams());
    const filters = useEarningsReportFilterStore((state) => state.filters);
    const exportParams = getEarningReportTransactionsParams(dateParams, filters, "xlsx");

    return (
        <FadeIn>
            <div className="w-full px-6 pb-6">
                <div className="flex items-center justify-between pb-2">
                    <div>
                        <Switch.Group>
                            <Switch
                                size="large"
                                isChecked={isGroupByReservationist}
                                onChange={setIsGroupByReservationist}
                            />
                            <Switch.Label direction="left" className="ml-2 text-base font-bold">
                                Group by Reservationist
                            </Switch.Label>
                        </Switch.Group>
                    </div>
                    <div
                        className="flex items-center justify-between "
                        data-testid="earnings-report-transactions-export-transactions-button"
                    >
                        <SecondaryButton icon={<ExportIcon />} onClick={exportModal.show}>
                            Export Transactions
                        </SecondaryButton>
                    </div>
                </div>
                {isGroupByReservationist ? (
                    <GroupByReservationist onChangeGroupByReservationist={setIsGroupByReservationist} />
                ) : (
                    <EarningsReportTransactionsList />
                )}
            </div>
            <ExportTransactionsModal isOpen={exportModal.isVisible} params={exportParams} onClose={exportModal.hide} />
        </FadeIn>
    );
};
